import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Navbar extends Component {
  state = {
    menuVisible: false
  };

  onMenuHandler = () => {
    this.setState({
      menuVisible: !this.state.menuVisible
    });
  };

  render() {
    let mobileVisible;
    let classChange;
    let bgEvent;
    if (this.state.menuVisible === false) {
      mobileVisible = 'navbar__mobile__container hidden';
      classChange = 'menu';
      bgEvent = 'bgEvent';
    } else {
      mobileVisible = 'navbar__mobile__container visible';
      classChange = 'menu change';
      bgEvent = 'bgEvent visible';
    }
    return (
      <div className="navbar">
        <div className="navbar__desktop">
          <div className="navbar__container--left">
            <NavLink
              exact
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/"
            >
              Home
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/price-guarantee"
            >
              Price Guarantee
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/satisfaction-guarantee"
            >
              Satisfaction Guarantee
            </NavLink>
          </div>
          <div className="navbar__logoContainer">
            <NavLink to="/">
              <img
                src="./assets/finalLogo.png"
                alt=""
                className="navbar__logoContainer__logo"
              />
            </NavLink>
          </div>
          <div className="navbar__container--right">
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/rewards"
            >
              MSI Rewards
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/shipping"
            >
              Shipping Times
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/forms"
            >
              Order Forms
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__link"
              to="/contact"
            >
              Contact
            </NavLink>
          </div>
        </div>
        <div className="navbar__mobile">
          <div className={bgEvent} onClick={this.onMenuHandler} />
          <div className="navbar__mobile__logoContainer">
            <NavLink to="/">
              <img
                src="./assets/finalLogo.png"
                alt=""
                className="navbar__logoContainer__logo"
              />
            </NavLink>
          </div>
          <div className={classChange} onClick={this.onMenuHandler}>
            <div className="bar1" />
            <div className="bar2" />
            <div className="bar3" />
          </div>
          <div className={mobileVisible}>
            <NavLink
              exact
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/"
              onClick={this.onMenuHandler}
            >
              Home
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/price-guarantee"
              onClick={this.onMenuHandler}
            >
              Price guarantee
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/satisfaction-guarantee"
              onClick={this.onMenuHandler}
            >
              Satisfaction Guarantee
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/rewards"
              onClick={this.onMenuHandler}
            >
              MSI Rewards
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/shipping"
              onClick={this.onMenuHandler}
            >
              Shipping Times
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/forms"
              onClick={this.onMenuHandler}
            >
              Order Forms
            </NavLink>
            <NavLink
              activeStyle={{ color: '#ee272e' }}
              className="navbar__mobile__container__link"
              to="/contact"
              onClick={this.onMenuHandler}
            >
              Contact Us
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js